// fastenersData.js - данные по крепежам

const fastenersData = {
  "YKRS-01": {
    displayName: 'YKRS-01',
    diameter: 40, // ширина крепежа в мм
    length: 507.83, // ПОЛНАЯ высота крепежа в мм (от начала FASTENER до конца нижнего CLAMP)
    fileName: 'YKRS-01.DXF',
    adjustableLength: false, // крепеж не регулируется по длине
    isDiameterFixed: true,
    mainCategory: 'Настенные',
    subCategory: 'Круглые изделия',
    layers: ['FASTENER', 'CLAMP'], // слои, используемые в DXF
    description: 'Крепеж усиленный для коллекторов серии GSK/GK из нержавеющей стали весом до 30кг.',
    // Вес и стоимость не учитываются для крепежей
    
    // Базовые параметры для трансформации
    baseAxialDistance: 300, // базовое межосевое расстояние в мм
    baseFastenerHeight: 480, // базовая высота FASTENER слоя в мм
    baseClampDiameter: 88.9, // базовый диаметр зажимов в мм
    overhangRange: { min: 100, max: 250, standard: 150 }, // вылет: ось трубы до стены
    
    // Точки привязки и подсветка только для слоя CLAMP (зажимные контуры)
    snapPointsLayerFilter: 'CLAMP', // показывать точки привязки только для этого слоя
    
    // Кастомные точки привязки для зажимов
    // Два зажима, каждый высотой 92.9 мм, ширина 15 мм
    // После масштабирования до diameter=40: центр зажима X = 20.15 * (40/40.15) = 20
    // Y координаты: верхний зажим 114.93-207.83, нижний зажим 414.93-507.83
    // 3 точки по вертикали на центральной оси каждого зажима
    snapPoints: [
      // ВЕРХНИЙ ЗАЖИМ - центральная ось
      { absolute: true, x: 20, y: 46.45 },       // Середина (46.45 от начала зажима, 92.9/2)
      
      // НИЖНИЙ ЗАЖИМ - центральная ось
      { absolute: true, x: 20, y: 346.45 },       // Середина (46.45 от начала зажима)
    ],
  },
  "YKRS-02": {
    displayName: 'YKRS-02',
    diameter: 40, // ширина крепежа в мм (будет масштабироваться)
    length: 587.83, // ПОЛНАЯ высота крепежа в мм (от 61.38 до 649.21)
    fileName: 'YKRS-02.DXF',
    adjustableLength: false, // крепеж не регулируется по длине
    isDiameterFixed: true,
    mainCategory: 'Настенные',
    subCategory: 'Круглые изделия',
    layers: ['FASTENER', 'CLAMP'], // слои, используемые в DXF
    description: 'Крепеж усиленный для коллекторов серии GSK/GK из нержавеющей стали весом свыше 30кг.',
    // Вес и стоимость не учитываются для крепежей
    
    // Базовые параметры для трансформации
    baseAxialDistance: 300, // базовое межосевое расстояние в мм (602.76 - 302.76)
    baseFastenerHeight: 540, // базовая высота FASTENER слоя в мм (601.38 - 61.38)
    baseClampDiameter: 88.9, // базовый диаметр зажимов в мм (92.9 - 4)
    overhangRange: { min: 100, max: 500, standard: 150 }, // вылет: ось трубы до стены
    
    // Точки привязки и подсветка только для слоя CLAMP (зажимные контуры)
    snapPointsLayerFilter: 'CLAMP', // показывать точки привязки только для этого слоя
    
    // Два хомута по 92.9 мм. После инверсии Y верхний центр 46.45, нижний 346.45.
    snapPoints: [
      { absolute: true, x: 20, y: 46.45 },
      { absolute: true, x: 20, y: 346.45 },
    ],
  },
  "YKWK-01": {
    displayName: 'YKWK-01',
    diameter: 40,
    length: 260,
    fileName: 'YKWK-01.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    hasAxialDistance: false,
    mainCategory: 'Настенные',
    subCategory: 'Круглые изделия',
    layers: ['FASTENER', 'CLAMP'],
    description: 'Крепеж усиленный для коллекторов серии WK из нержавеющей стали весом до 30кг.',
    baseFastenerHeight: 260,
    baseClampDiameter: 76.1,
    overhangRange: { min: 100, max: 250, standard: 150 },
    snapPointsLayerFilter: 'CLAMP',
    snapPoints: [
      { absolute: true, x: 20, y: 105.02 },
    ],
  },
  "YKWK-02": {
    displayName: 'YKWK-02',
    diameter: 40,
    length: 300,
    fileName: 'YKWK-02.DXF',
    adjustableLength: false,
    isDiameterFixed: true,
    hasAxialDistance: false,
    mainCategory: 'Настенные',
    subCategory: 'Круглые изделия',
    layers: ['FASTENER', 'CLAMP'],
    description: 'Крепеж усиленный для коллекторов серии WK из нержавеющей стали весом свыше 30кг.',
    baseFastenerHeight: 300,
    baseClampDiameter: 88.9,
    overhangRange: { min: 100, max: 500, standard: 150 },
    snapPointsLayerFilter: 'CLAMP',
    snapPoints: [
      { absolute: true, x: 20, y: 78.62 },
    ],
  },
  
  // ============================================
  // НАПОЛЬНЫЕ КРЕПЕЖИ
  // ============================================
  
  "KRNS-GS-03": {
    displayName: 'KRNS-GS-03',
    diameter: 293.02, // ширина крепежа в мм (фиксированная)
    length: 555, // БАЗОВАЯ высота крепежа в мм (из DXF)
    fileName: 'KRNS-GS-03.DXF',
    adjustableLength: true, // крепеж регулируется по высоте
    isDiameterFixed: true,
    mainCategory: 'Напольные',
    isFloorFastener: true, // Флаг для идентификации напольного крепежа
    floorFastenerCropFromTop: true, // Обрезать сверху, а не масштабировать
    layers: ['FASTENER', 'CLAMP'], // слои, используемые в DXF (нужно уточнить)
    description: 'Крепеж напольный регулируемый из нержавеющей стали, для изделий диаметром до 168.3.',
    
    // Параметры высоты для напольных крепежей
    minHeight: 340, // минимальная высота в мм (обрезается сверху)
    maxHeight: 555, // максимальная высота в мм (базовая из DXF)
    baseHeight: 555, // базовая высота в мм (из DXF)
    lowerPipeLength: 250, // труба Ø48,3, её длиной сдвигается весь диапазон
    pipeFloorClearance: 85, // от пола до открытого конца Ø48,3; ниже смещение упирается в пол
    rangeRaiseMax: 545, // насколько можно поднять диапазон
    
    // Базовые параметры (не используются для напольных, но оставляем для совместимости)
    baseAxialDistance: 300,
    baseFastenerHeight: 555,
    baseClampDiameter: 88.9,
    
    // Кастомные точки привязки
    snapPoints: [
      { absolute: true, x: 146.51, y: 0 },      // Верхний центр (для муфты)
    ],
  },
  
  "KRNS-GS-04": {
    displayName: 'KRNS-GS-04',
    diameter: 293.02, // ширина крепежа в мм (фиксированная)
    length: 555, // БАЗОВАЯ высота крепежа в мм (из DXF)
    fileName: 'KRNS-GS-04.DXF',
    adjustableLength: true, // крепеж регулируется по высоте
    isDiameterFixed: true,
    mainCategory: 'Напольные',
    isFloorFastener: true, // Флаг для идентификации напольного крепежа
    floorFastenerCropFromTop: true, // Обрезать сверху, а не масштабировать
    layers: ['FASTENER', 'CLAMP'], // слои, используемые в DXF (нужно уточнить)
    description: 'Крепеж напольный регулируемый из нержавеющей стали, для изделий диаметром до 273.',
    
    // Параметры высоты для напольных крепежей
    minHeight: 400, // минимальная высота в мм (обрезается сверху)
    maxHeight: 600, // максимальная высота в мм (может растягиваться)
    baseHeight: 555, // базовая высота в мм (из DXF)
    heightStep: 50, // шаг изменения высоты в мм
    lowerPipeLength: 275, // труба Ø48,3, её длиной сдвигается весь диапазон
    pipeFloorClearance: 85, // от пола до открытого конца Ø48,3; ниже смещение упирается в пол
    rangeRaiseMax: 500, // насколько можно поднять диапазон
    
    // Базовые параметры (не используются для напольных, но оставляем для совместимости)
    baseAxialDistance: 300,
    baseFastenerHeight: 555,
    baseClampDiameter: 88.9,
    
    // Кастомные точки привязки
    snapPoints: [
      { absolute: true, x: 146.51, y: 0 },      // Верхний центр (для муфты)
    ],
  },
  
  "Крепеж напольный нерегулируемый": {
    displayName: 'Кр. напольный (нерег.)',
    diameter: 293.02, // ширина крепежа в мм (фиксированная)
    length: 555, // БАЗОВАЯ высота крепежа в мм (из DXF)
    fileName: 'Крепеж напольный нерегулируемый.DXF',
    adjustableLength: true, // крепеж регулируется по высоте (максимальная высота 1100)
    isDiameterFixed: true,
    mainCategory: 'Напольные',
    isFloorFastener: true, // Флаг для идентификации напольного крепежа
    floorFastenerCropFromTop: true, // Обрезать сверху при уменьшении
    floorFastenerStretchFromSplit: true, // При увеличении тянуть верхнюю часть, нижняя фиксирована
    fixedBottomHeight: 200, // высота фиксированной нижней части в мм
    layers: ['FASTENER', 'CLAMP'], // слои, используемые в DXF (нужно уточнить)
    description: 'Крепеж напольный нерегулируемый из нержавеющей стали, для изделий диаметром до 273.',
    
    // Параметры высоты для напольных крепежей
    minHeight: 170, // минимальная высота в мм (обрезается сверху)
    maxHeight: 1100, // максимальная высота в мм (может растягиваться)
    baseHeight: 555, // базовая высота в мм (из DXF)
    
    // Базовые параметры (не используются для напольных, но оставляем для совместимости)
    baseAxialDistance: 300,
    baseFastenerHeight: 555,
    baseClampDiameter: 88.9,
    
    // Кастомные точки привязки
    snapPoints: [
      { absolute: true, x: 146.51, y: 0 },      // Верхний центр (для муфты)
    ],
  },
  
  "KRGB": {
    displayName: 'KRGB (от ⌀323.9 мм)',
    diameter: 406.4, // ширина крепежа в мм (из DXF)
    length: 400, // БАЗОВАЯ высота крепежа в мм (из DXF)
    fileName: 'KRGB.DXF',
    adjustableLength: true, // крепеж регулируется по высоте
    isDiameterFixed: false, // Диаметр изменяемый (для труб 323.9-609.6)
    mainCategory: 'Напольные',
    isFloorFastener: true,
    isLargePipeFastener: true, // Специальный флаг для крепежа больших труб
    noMufta: true, // Муфта не добавляется для этого крепежа
    includedInPrice: true, // Крепеж включен в стоимость изделия
    stretchFromMiddle: true, // Растягивать от середины (не обрезать сверху)
    layers: ['FASTENER', 'CLAMP'],
    description: 'Крепеж напольный нерегулируемый KRGB для труб больших диаметров от ⌀323.9 мм.',
    
    // Параметры высоты
    minHeight: 200, // минимальная высота в мм
    maxHeight: 1000, // максимальная высота в мм
    baseHeight: 400, // базовая высота в мм (из DXF)
    
    // Диаметры труб, которые поддерживает этот крепеж
    supportedDiameters: [323.9, 355.6, 406.4, 508, 609.6],
    
    // Базовые параметры
    baseAxialDistance: 300,
    baseFastenerHeight: 400,
    baseClampDiameter: 88.9,
    
    // Кастомные точки привязки
    snapPoints: [
      { relative: true, x: 0.5, y: 0 },      // Верхний центр (относительная координата)
    ],
  },
};

function formatSize(value) {
  const number = Math.round(Number(value) * 10) / 10;
  if (!Number.isFinite(number)) return '0';
  return Number.isInteger(number) ? String(number) : String(number);
}

/** Нестандартный размер: YKRS-01(114,350,120) или YKWK-01(114,120). */
export function fastenerDisplayName(fastener) {
  const key = fastener?.itemKey || '';
  const base = fastenersData[key]?.displayName || key;
  const overhang = Number(fastener?.overhang);
  const overhangValue = Number.isFinite(overhang) ? overhang : 150;
  const diameter = Math.round(Number(fastener?.clampDiameter) || 0);
  if (key === 'YKRS-01' || key === 'YKRS-02') {
    const axial = Number(fastener.axialDistance);
    const axialValue = Number.isFinite(axial) ? axial : 0;
    if (!(axialValue > 300 || overhangValue !== 150)) return base;
    return `${base}(${diameter},${formatSize(axialValue)},${formatSize(overhangValue)})`;
  }
  if (key === 'YKWK-01' || key === 'YKWK-02') {
    if (overhangValue === 150) return base;
    return `${base}(${diameter},${formatSize(overhangValue)})`;
  }
  if (key === 'Крепеж напольный нерегулируемый') {
    const stored = Number(fastener?.fastenerHeight);
    const height = Number.isFinite(stored) && stored > 0 ? stored + 22 : null;
    if (height == null) return base;
    return `${base}(${formatSize(height)})`;
  }
  if (key === 'KRNS-GS-03' || key === 'KRNS-GS-04') {
    const offset = Number(fastener?.rangeOffset) || 0;
    const spec = fastenersData[key];
    if (spec && Math.abs(offset) >= 0.5) {
      const min = Math.round((Number(spec.minHeight) || 0) + offset);
      const max = Math.round((Number(spec.maxHeight) || 0) + offset);
      return `${base}(${min}-${max})`;
    }
  }
  return base;
}

const WORKSHOP_FASTENERS = ['YKRS-01', 'YKRS-02', 'YKWK-01', 'YKWK-02'];

/**
 * Крепежи для цеха. Чертёж YKRS-02, YKWK-01 и YKWK-02 всегда,
 * у YKRS-01 только при новом имени.
 * Резка YKRS-01 — только при новом имени.
 * Резка YKRS-02 и обоих YKWK — всегда, профиль вылета не шлётся при вылете 150.
 * Одинаковые названия дают один комплект файлов.
 */
export function workshopFastenerJobs(fittings) {
  const jobs = new Map();
  (fittings || []).forEach((fastener) => {
    if (fastener?.type !== 'fastener' || fastener.isHidden) return;
    const key = fastener.itemKey;
    if (key === 'KRNS-GS-03' || key === 'KRNS-GS-04') {
      const rangeOffset = Number(fastener.rangeOffset) || 0;
      if (Math.abs(rangeOffset) < 0.5) return;
      const name = fastenerDisplayName(fastener);
      if (jobs.has(name)) {
        jobs.get(name).count += 1;
        return;
      }
      jobs.set(name, {
        partKey: key,
        name,
        count: 1,
        needsDrawing: true,
        needsProfiles: true,
        rangeOffset,
        height: Number(fastener.fastenerHeight) || 0,
      });
      return;
    }
    if (!WORKSHOP_FASTENERS.includes(key)) return;
    const name = fastenerDisplayName(fastener);
    const renamed = name !== key;
    if (key === 'YKRS-01' && !renamed) return;
    if (jobs.has(name)) {
      jobs.get(name).count += 1;
      return;
    }
    const overhang = Number(fastener.overhang);
    const axial = Number(fastener.axialDistance);
    jobs.set(name, {
      partKey: key,
      name,
      count: 1,
      needsDrawing: key !== 'YKRS-01' || renamed,
      needsProfiles: key !== 'YKRS-01' || renamed,
      weldRub: key === 'YKRS-01' ? 141 : undefined,
      clampDiameter: Number(fastener.clampDiameter) || undefined,
      axialDistance: Number.isFinite(axial) ? axial : 300,
      overhang: Number.isFinite(overhang) ? overhang : 150,
    });
  });
  return Array.from(jobs.values());
}

export default fastenersData;
